import EnsurePermission from './EnsurePermission';
import url from 'url';
import {useHistory, useLocation} from 'react-router-dom';
import {FC, ReactElement} from 'react';
import {EntityFieldType, QueryParamsProps} from '../../constants/types';
import {
  ReactComponent as AscSortIcon
} from '../../assets/images/asc-sort-icon.svg';
import {
  ReactComponent as DescSortIcon
} from '../../assets/images/desc-sort-icon.svg';
import classNames from 'classnames';

interface TableHeaderRowProps {
  query?: Nullable<QueryParamsProps>,
  tableData: EntityFieldType[],
  hasIconComponent?: boolean,
  headerRowClassName?: string
}

const TableHeaderRow: FC<TableHeaderRowProps> = ({
  query= null,
  tableData,
  hasIconComponent=false,
  headerRowClassName='header-row'
}) => {
  const history = useHistory();
  const {pathname} = useLocation();
  const sortDirection = query?.direction || 'asc';
  const sortedBy = query?.sort || '';

  const sortTableItems = (sortName: string) => {
    if (!query) return;

    if (sortName === sortedBy) {
      const currentSortDirection = sortDirection === 'desc' ? 'asc' : 'desc';
      history.push(
          url.format({
            pathname,
            query: {...query, direction: currentSortDirection}
          }));
    } else {
      history.push(
          url.format({
            pathname,
            query: {...query, direction: 'asc', sort: sortName}
          }));
    }
  };

  const headerCells = tableData.map(({
    name,
    label,
    sortName,
    className,
    permission}) => {
    const sortIcon: Nullable<ReactElement> =
      sortName === sortedBy && sortDirection === 'asc' ? <AscSortIcon/> :
      sortName === sortedBy && sortDirection === 'desc' ? <DescSortIcon/> :
      null;

    return (
      <EnsurePermission
        key={name}
        elementPermissions={permission ? [...permission] : null}>
        <th className={className || 'cell header-cell'}>
          {label &&
            <div className="header-cell-wrapper">
              <span
                className={classNames('column-title', {'cursor-pointer': sortName})}
                onClick={() => sortName ? sortTableItems(sortName) : null}>
                {label}
              </span>
              {!!sortIcon &&
                <span
                  className="sort-icon cursor-pointer"
                  onClick={() => sortName ? sortTableItems(sortName) : null}>
                  {sortIcon}
                </span>}
            </div>}
        </th>
      </EnsurePermission>
    );
  });

  return (
    <tr className={headerRowClassName ? headerRowClassName : ''}>
      {headerCells}
      {/* fix table header border for safari */}
      {hasIconComponent && <th className="narrow-cell" />}
    </tr>
  );
};

export default TableHeaderRow;
